import { render, staticRenderFns } from "./lesson.vue?vue&type=template&id=a2072c5c&scoped=true&"
import script from "./lesson.vue?vue&type=script&lang=js&"
export * from "./lesson.vue?vue&type=script&lang=js&"
import style0 from "./lesson.vue?vue&type=style&index=0&id=a2072c5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2072c5c",
  null
  
)

export default component.exports